/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ categoryTitle: NonNullable<unknown> }} Cuddly_Direct_Raven_SlurpInputs */

const fr_cuddly_direct_raven_slurp = /** @type {(inputs: Cuddly_Direct_Raven_SlurpInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`La catégorie "${i?.categoryTitle}" a été supprimée avec succès.`)
};

/**

* @param {Cuddly_Direct_Raven_SlurpInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const cuddly_direct_raven_slurp = /** @type {((inputs: Cuddly_Direct_Raven_SlurpInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cuddly_Direct_Raven_SlurpInputs, { locale?: "fr" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_cuddly_direct_raven_slurp(inputs)
});